import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import FlagIcon from 'vue-flag-icon';
import pdfvuer from 'pdfvuer';
import VueInputMask from "vue-inputmask";
import VueTheMask from 'vue-the-mask';
import VueSimpleAlert from "vue-simple-alert";
import './registerServiceWorker';
import './assets/scss/app.scss';
import '@/assets/css/app.css';
import '@/assets/css/materialdesignicons.min.css';

import 'bulma-modal-fx/dist/css/modal-fx.min.css';
import 'material-icons/iconfont/material-icons.css';
import 'bulma-badge/dist/css/bulma-badge.min.css';

import './globalplugins';
import './globalcomponents';
import './globalFilters';
import './globalDirectives';
import VueCurrencyInput from 'vue-currency-input'
import VueExcelXlsx from "vue-excel-xlsx";
//AvatarCropper
import AvatarCropper from "vue-avatar-cropper";

Vue.component("avatar-cropper", AvatarCropper);
Vue.component('pdf', pdfvuer);
Vue.component('vueMask', VueInputMask);
Vue.use(VueCurrencyInput)

// QuillEditor
import VueQuillEditor from "vue-quill-editor";
import './assets/katex/katex.min.js';
import { ImageResize } from './assets/quill-image-resize-module/image-resize.min.js';

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "katex/dist/katex.css";
import "quill-better-table/dist/quill-better-table.css";
import "quill/dist/quill.snow.css";

Vue.use(VueQuillEditor)
Vue.use(FlagIcon);
Vue.use(VueTheMask)
Vue.use(VueSimpleAlert);
Vue.use(VueExcelXlsx);

import 'moment-countdown/dist/moment-countdown.js';

import myMSALObj from './config/azure-b2c/settings';
Vue.prototype.$authService = myMSALObj;

import Axios from "axios";

Vue.prototype.$http = Axios;

export var bus = new Vue();


Vue.config.productionTip = false;

// filters
import moment from "moment";

Vue.filter('LLLL', (value: any) => {
  if (!value) return ''
  return moment(value).format('LLLL');
});


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      var permission = to.matched[to.matched.length - 1].meta.permissionValue | to.matched[to.matched.length - 1].meta.permissionValue;
      const user = JSON.parse(localStorage.getItem("user") as any) as any;
      if (!user) {
        if (from.path != "/inicio")
          next("/inicio");
        return;
      }
      if (
        user.isAdmin ||
        !permission ||
        user.permissions.some((x: any) => x.permissionValue == permission)
      ) {
        next();
        return;
      } else if (permission) {
        if (from.path != "/inicio")
          next("/inicio");
        return;
      }
    }
  }
  next();
});

import i18n from '@/Plugin/i18n';
window.onload = () => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
};



